var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_294_9274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.33331 5.95825L7.77659 10.0067C8.21737 10.3345 8.43776 10.4984 8.67749 10.5619C8.88924 10.618 9.11072 10.618 9.32247 10.5619C9.5622 10.4984 9.78259 10.3345 10.2234 10.0067L15.6666 5.95825M5.53331 15.1666H12.4666C13.5868 15.1666 14.1468 15.1666 14.5746 14.935C14.951 14.7312 15.2569 14.4062 15.4487 14.0063C15.6666 13.5518 15.6666 12.9567 15.6666 11.7666V7.23325C15.6666 6.04314 15.6666 5.44808 15.4487 4.99352C15.2569 4.59368 14.951 4.26859 14.5746 4.06486C14.1468 3.83325 13.5868 3.83325 12.4666 3.83325H5.53331C4.41321 3.83325 3.85316 3.83325 3.42533 4.06486C3.04901 4.26859 2.74305 4.59368 2.5513 4.99352C2.33331 5.44808 2.33331 6.04314 2.33331 7.23325V11.7666C2.33331 12.9567 2.33331 13.5518 2.5513 14.0063C2.74305 14.4062 3.04901 14.7312 3.42533 14.935C3.85316 15.1666 4.41321 15.1666 5.53331 15.1666Z",
    stroke: "#1B1D52",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_294_9274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email_icon.ba6b51f5cb012e932cdaa8e977fbd7f7.svg";
export { ForwardRef as ReactComponent };